export default __webpack_public_path__ + "static/media/play_cards_mockup_short.b058f926.png";